<template>
	<aside
		class="property"
		:class="{ 'shrink': !isVisible, 'bg-color-editing': isUserEditing !== user.id && isUserEditing }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Marker Properties ') }} - {{ label ? label.toUpperCase() : 'Default Marker Properties' }}
			</div>
			<button
				class="btn btn-default btn-sm btn-icon property-toggle"
				@click="isVisible = !isVisible">
				<i class="material-icons" v-if="isVisible">chevron_left</i>
				<i class="material-icons" v-else>chevron_right</i>
			</button>
		</div>
			<div class="property-content pr-2" :class="{'pointer-events-none': isLocked    ? isLocked.is_locked   : true}">
				<div >
					<label class="text-primary">{{ $t('Marker Property') }} </label>
					<custom-input
						class="mb-3"
						align="left"
						:label="$t('Item Label')"
						:required="isRequired"
						@blur="save"
						@keyenter="save"
						v-model="label"
						:restrictChar="true"
					/>
				</div>
				<!-- Border -->
				<div>
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Color Style') }}</label>
						</div>
					</div>
				</div>
				<div class="row mb-0 pb-0">
					<div class="col-md-6">
						<custom-input
							class="mb-4 pb-0"
							type="color"
							:label="$t('Font')"
							:required="isRequired"
							:min="0"
							:max="1000"
							:step="1"
							@input="onKeywordChange"
							@keyenter="save"
							v-model="SeparatorFontColor"
						/>
					</div>
					<div class="col-md-6">
						<custom-input
							type="color"
							align="left"
							picker-position="right"
							:label="$t('BG Color')"
							:required="isRequired"
							@input="onKeywordChange"
							@keyenter="save"
							v-model="SeparatorBGColor"
						/>
					</div>
				</div>
			</div>
	</aside>
</template>

<script>
import { mapGetters } from 'vuex';
import { delay } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
// import fileApi from '@/api/file';
import CustomInput from '@/components/CustomInput.vue';

export default {
	name: 'SeparatorProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		media: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		CustomInput,
	},
	data() {
		return {
			customPageUrl: '',
			isLoading: false,
			label: '',
			layerIndex: 0,
			isVisible: true,
			isRequired: false,
			SeparatorFontColor: '#FFFFFFFF',
			SeparatorBGColor: '#FF5700',
			isSaving: false,
			isActiveEdit: false,
		};
	},
	methods: {
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				let content = this.data.content;
				this.label = this.data.name;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				if (content) {
					this.layerIndex = this.data.layer_index;
					this.SeparatorFontColor = content.SeparatorFontColor;
					this.SeparatorBGColor = content.SeparatorBGColor;
				}
			}
		},
		reset() {
			this.label = '';
		},
		onKeywordChange() {
			delay(() => {
				this.save();
				// this.fetch(true);
			}, 1200);
		},
		save() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			rundownItemsApi.update(this.data.id, this.customPageParams, callback, errorCallback);
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		resetSizePosition() {
			this.x = 0;
			this.y = 0;
			this.position = 'default';
			this.width = 1920;
			this.height = 1080;
			this.save();
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		customPageParams() {
			const content = {
				label: this.label,
				SeparatorFontColor: this.SeparatorFontColor,
				SeparatorBGColor: this.SeparatorBGColor,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.label || 'Default MARKER',
				type: this.type,
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	watch: {
		data() {
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				} else {
					this.isActiveEdit = false;
				}
				if (this.data) {
					let content = this.data.content;
					this.label = this.data.name;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					if (content) {
						this.layerIndex = this.data.layer_index;
						this.SeparatorFontColor = content.SeparatorFontColor;
						this.SeparatorBGColor = content.SeparatorBGColor;
					}
				}
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		this.isRequired = false;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 400);
	},
};
</script>
